/*! Copyright (c) Safe As Milk. All rights reserved. */
import { recentHistory } from "./recent-search-history.js";
class SearchForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
    }
    connectedCallback() {
        if (this.hasAttribute("add-recent-search-on-load")) this.addFormStateToRecentSearches();
    }
    static addRecentSearch(query, uri) {
        recentHistory.add(query, uri);
    }
    addFormStateToRecentSearches() {
        if (!this.form) return;
        const form = new FormData(this.form);
        const search = new URLSearchParams(form);
        const action = new URL(this.form.getAttribute("action") || "/search", window.location.origin);
        if (action.origin !== window.location.origin) return;
        const combinedSearch = new URLSearchParams({
            ...Object.fromEntries(action.searchParams),
            ...Object.fromEntries(search)
        });
        action.search = combinedSearch.toString();
        SearchForm.addRecentSearch(form.get("q"), action.href);
    }
}
if (!customElements.get("search-form")) customElements.define("search-form", SearchForm);
